/**
 * NO03 - Fakturakopi Saga
 */

import { put, call } from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import * as actions from '../actions';
import * as actionsNO03 from '../actions/indexNO03';
import * as APICalls from '../../felles/APICalls_NO03';
import NO03 from '../../models/NO03';
import FirmNavnId from '../../models/FirmNavnId';

/**
 * Search for invoices
 */
export function* searchNO03InvoicesSaga(action: any) {
  try {
    yield put(actions.setIsloading(true));
    const { payload: searchParams } = action;

    // Add pagination parameters
    const paginatedParams = {
      ...searchParams,
      page: 0,
      pageSize: 100,
    };

    const response = yield call(APICalls.searchInvoices, paginatedParams);

    if (response?.data) {
      const invoices: NO03[] = response.data.content || [];
      const hasMore = invoices.length >= 100; // If we got 100 items, there might be more

      yield put(actionsNO03.NO03SearchSuccess(invoices, 0, hasMore));
    }
  } catch (error: any) {
    yield put(actionsNO03.NO03SearchFailure(error?.message || 'Failed to search invoices'));
    yield put(actions.showError(error?.message || 'Failed to search invoices'));
  } finally {
    yield put(actions.setIsloading(false));
  }
}

/**
 * Load more invoices (next page)
 */
export function* loadMoreNO03InvoicesSaga(action: any) {
  try {
    const { payload: searchParams } = action;

    const response = yield call(APICalls.searchInvoices, searchParams);

    if (response?.data) {
      const invoices: NO03[] = response.data.content || [];
      const hasMore = invoices.length >= 100;

      yield put(actionsNO03.NO03LoadMoreSuccess(invoices, hasMore));
    }
  } catch (error: any) {
    yield put(actionsNO03.NO03LoadMoreFailure(error?.message || 'Failed to load more invoices'));
  }
}

/**
 * Load firma list for the user
 */
export function* loadNO03FirmaListSaga() {
  try {
    const response = yield call(APICalls.getFirmaList);

    if (response?.data) {
      const firmaList: FirmNavnId[] = response.data;
      yield put(actionsNO03.NO03LoadFirmaListSuccess(firmaList));
    }
  } catch (error: any) {
    yield put(actionsNO03.NO03LoadFirmaListFailure(error?.message || 'Failed to load firma list'));
    yield put(actions.showError(error?.message || 'Failed to load firma list'));
  }
}

/**
 * Export invoices to Excel
 */
export function* exportNO03ToExcelSaga(action: any) {
  try {
    yield put(actions.setIsloading(true));
    const { payload: searchParams } = action;

    const response = yield call(APICalls.exportInvoicesToExcel, searchParams);

    if (response?.data) {
      yield fileDownload(response.data, `Fakturakopi_${Date.now()}.xlsx`);
    }
  } catch (error: any) {
    yield put(actions.showError(error?.message || 'Failed to export to Excel'));
  } finally {
    yield put(actions.setIsloading(false));
  }
}
